import { AUTH0_AUDIENCE, CHECKOUT_URL, PORTAL_URL } from '../constants/api';
import { trackEvent } from './analytics';

const getBillingToken = (getAccessTokenSilently) => getAccessTokenSilently({
  authorizationParams: { audience: AUTH0_AUDIENCE },
});

export const isStripeCheckoutUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:'
      && (url.hostname === 'checkout.stripe.com' || url.hostname.endsWith('.checkout.stripe.com'));
  } catch {
    return false;
  }
};

export const isStripePortalUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:'
      && (url.hostname === 'billing.stripe.com' || url.hostname.endsWith('.billing.stripe.com'));
  } catch {
    return false;
  }
};

export const startSubscriptionCheckout = async (
  getAccessTokenSilently,
  { mode = 'trial', subscriptionTier = 'core' } = {},
) => {
  const token = await getBillingToken(getAccessTokenSilently);
  const response = await fetch(CHECKOUT_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ mode, subscriptionTier }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !isStripeCheckoutUrl(payload.url)) {
    throw new Error(payload.error || payload.message || 'Unable to start checkout');
  }
  const price = subscriptionTier === 'research' ? 249 : 29;
  trackEvent('begin_checkout', {
    currency: 'USD',
    value: price,
    plan_id: subscriptionTier,
    subscription_tier: subscriptionTier,
    checkout_mode: mode,
    items: [{
      item_id: subscriptionTier,
      item_name: subscriptionTier === 'research' ? 'Research Suite' : 'Core',
      item_category: 'subscription',
      price,
      quantity: 1,
    }],
  });
  window.location.href = payload.url;
};

export const openCustomerPortal = async (getAccessTokenSilently) => {
  const token = await getBillingToken(getAccessTokenSilently);
  const response = await fetch(PORTAL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !isStripePortalUrl(payload.url)) {
    throw new Error(payload.error || payload.message || 'Unable to open billing portal');
  }
  trackEvent('select_content', { content_type: 'billing_portal', item_id: 'manage_subscription' });
  window.location.href = payload.url;
};
